import { slideDown, slideUp } from '../core/effects.js';

export function initTechnologies() {
  document.querySelectorAll('.technologies__tabs .options__input').forEach((tab) => {
    if (tab.dataset.webtenseTechnologiesInit) {
      return;
    }

    tab.dataset.webtenseTechnologiesInit = 'true';
    const techItems = tab.closest('.technologies').querySelectorAll('.technologies__item');

    techItems.forEach((item) => {
      if (tab.checked && tab.value === item.dataset.tech) {
        item.classList.add('_active');
        item.parentElement.classList.add('_active');
      }
    });

    tab.addEventListener('change', () => {
      techItems.forEach((item) => {
        item.classList.remove('_active');
        item.parentElement.classList.remove('_active');
        if (tab.value === item.dataset.tech) {
          item.classList.add('_active');
          item.parentElement.classList.add('_active');
        }
      });
    });
  });

  if (document.documentElement.dataset.webtenseTechnologiesBlockInit) {
    return;
  }

  document.documentElement.dataset.webtenseTechnologiesBlockInit = 'true';
  document.addEventListener('click', (event) => {
    const container = event.target.closest('.technologies__block-container');
    if (!container) {
      return;
    }

    container.classList.toggle('active');
    const content = container.nextElementSibling;
    if (container.classList.contains('active')) {
      slideDown(content, 200);
    } else {
      slideUp(content, 200);
    }
  });
}
